// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"55":"fbb68c77","594":"0da87dbf","661":"bbde5f88","958":"5cfb1430"}[chunkId] + ".js";
};